import type { UserReturnModel } from 'src/lib/api';

import { createAction } from '@reduxjs/toolkit';

export interface OrgMembersState {
  OrgMembers: UserReturnModel[];
}

export const initialState: OrgMembersState = {
  OrgMembers: [],
};

export const setOrgMembers = createAction<UserReturnModel[]>('orgMembers/setOrgMembers');
